export default __webpack_public_path__ + "static/media/hht2_ep04_timeline_q02_a.3ef2d2cd.png";